import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";


function TipoServicoList() {

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <ListView title={"Tipo serviço"}
                          id={`${process.env.REACT_APP_REST_TIPO_SERVICO}`}>
                    <Column field="nomeServico" header="Descrição" sortable />
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default TipoServicoList;